import axios from "axios";

export const state = {
    parents: [],
};

export const getters = {
    parents: state => state.parents,
};

export const mutations = {
    setParents(state, newValue) {
        state.parents = newValue
    },
};

export const actions = {
    fetchParents({ commit }) {
        axios.get('/parents').then(res => {
            commit('setParents', res.data.parents);
        })
    },
};
